
export default function StorySection() {
  const stories = [
    {
      title: "Our Story",
      content: `High Standards Smoke Shop was founded with a simple vision: to create a premium destination where quality meets affordability. We recognized a gap in the Central Florida market for a smoke shop that prioritizes authenticity, expertise, and customer service above all else. From our carefully curated product selection to our knowledgeable staff, every aspect of our business reflects our commitment to excellence.`,
      image:
        "https://static.readdy.ai/image/4f6582e073a5efa66fcf915170e338fb/ce19fc7a8066adcd8de7f723911251d5.jpeg",
    },
    {
      title: "Our Mission",
      content: `Our mission is to elevate the smoke shop experience by offering only the finest products paired with unparalleled customer service. We believe that every customer deserves access to premium vapes, hand-crafted glass, authentic hookah setups, and quality accessories—all in a welcoming, sophisticated environment. We're not just selling products; we're building lasting relationships with our community.`,
      image:
        "https://static.readdy.ai/image/4f6582e073a5efa66fcf915170e338fb/69376431182c239e017bb68b04c54e29.jpeg",
    },
  ];

  return (
    <section className="py-24 bg-deep-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="space-y-32">
          {stories.map((story, index) => (
            <div
              key={index}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? "lg:flex-row-reverse" : ""
              }`}
            >
              {/* Image */}
              <div className={index % 2 === 1 ? "lg:order-2" : ""}>
                <div className="relative rounded-2xl overflow-hidden h-[400px] lg:h-[500px] group">
                  <img
                    src={story.image}
                    alt={story.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 border-2 border-copper/0 group-hover:border-copper/50 transition-all duration-300 rounded-2xl"></div>
                </div>
              </div>

              {/* Content */}
              <div className={index % 2 === 1 ? "lg:order-1" : ""}>
                <div className="bg-forest-green rounded-2xl p-10 lg:p-12">
                  <div className="w-16 h-0.5 bg-copper mb-6"></div>
                  <h2 className="font-serif text-4xl lg:text-5xl text-white mb-6">
                    {story.title}
                  </h2>
                  <p className="text-gray-300 text-lg leading-relaxed">
                    {story.content}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
